import React from 'react';
import { useNavigate } from 'react-router-dom';
import CalendarPage from './CalendarPage';

const CalendarPageWrapper: React.FC = () => {
  const navigate = useNavigate();
  
  return <CalendarPage navigate={navigate} />;
};

export default CalendarPageWrapper;
